import { USE_GOOGLE_ANALYTICS } from '../config/vars';

export const googleAnalyticsInit = () => {
  if (!USE_GOOGLE_ANALYTICS) return false;
  window.gtag('config', 'UA-98192738-2');
};
